import { connect } from 'react-redux';
import {
  currentIterationSelector,
  getLatestIterationSelector,
  iterationsPickerSelector
} from 'state/selectors/iterations-picker';
import {
  createTeam,
  deleteTeam,
  getTeams,
  updateTeam,
  updateTeamContributors
} from 'state/callers/teams';
import { toggleModal, toggleSnackBar } from 'state/callers';
import { selectTeamId } from 'state/actions';
import { individualContributorsSelector } from 'state/selectors/contributors';
import {
  isTeamLicenseSelector,
  licenseSelector
} from 'state/selectors/license';
import Teams from './Teams';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { myAccountSelector } from 'state/selectors/account';
import { teamsWithExtraSyncedDataSelector } from 'state/selectors/teams';
import { selectedTeamSelector } from 'state/selectors/ui-state';

const mapStateToProps = state => ({
  selectedTeam: selectedTeamSelector(state),
  contributors: individualContributorsSelector(state),
  currentTeams: teamsWithExtraSyncedDataSelector(state),
  iterationsPickerData: iterationsPickerSelector(state),
  latestIteration: getLatestIterationSelector(state),
  currentIteration: currentIterationSelector(state),
  isTeamLicense: isTeamLicenseSelector(state),
  license: licenseSelector(state),
  account: myAccountSelector(state)
});

const mapDispatchToProps = {
  toggleModal,
  toggleSnackBar,
  selectTeamId,
  getTeams,
  createTeam,
  updateTeam,
  deleteTeam,
  updateTeamContributors
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Teams, 'Teams'));
